/**
 * The story's sounds, by moment: aliases of the app's story audio
 * (assets/audio/story), levelled to about -16 LUFS with peaks under -1 dBTP.
 */
export const STORY_SOUNDS = {
  /** A mystery box lands on the reels. */
  boxDrop: 'story:box_drop',
  boxOpen: 'story:box_open',
  /** A reel modifier starts. */
  mod: 'story:mod_shimmer',
  /** A rival character pops in. */
  rival: 'story:rival_chime',
  takings: 'story:takings_lullaby',
  morning: 'story:morning_birdsong',
  /** A visitor drops by with a game. */
  visitor: 'story:visitor_hello',
  /** A piece of the treasure map turns up. */
  mapPiece: 'story:map_piece',
  /** The treasure chest is dug up. */
  treasure: 'story:treasure_open',
} as const;
